import {GET_TICKETS} from './tickets.actionsTypes';

export default function canceledOrders(state = [], action) {
    let newState = Object.assign([], state);
    switch (action.type) {
        case GET_TICKETS:
            let tickets = Object.assign([], action.tickets);
            return tickets;
        default:
            return newState;
    }
}
